import ETracker from '@fuxi/eevee-tracker';
import { omit } from 'lodash-es';
import startETracker from '@fuxi/eevee-tracker-starter';
import { BuriedEventTrigger } from './const';
let sendEvent = null;
const initETracker = (config) => {
    const { platform, pid, env } = config;
    const { ETracker, sendEvent: _sendEvent } = startETracker(Object.assign(Object.assign({ plugins: ['pv', 'event'], 
        // pv插件的config设置
        plugin_pv: {
            autoPV: true,
            autoLeave: true,
            enableHistory: true,
        } }, config), { pid,
        env }));
    ETracker.setConfig({
        dim1: platform,
    });
    sendEvent = _sendEvent;
};
const sendTrackEvent = (param) => {
    const eventId = param.eventId;
    if (!sendEvent) {
        console.error('sendEvent请先调用initETracker');
        throw Error('sendEvent请先调用initETracker');
    }
    sendEvent(eventId, Object.assign({}, omit(param, ['eventId'])));
};
// 用于二次更新埋点设置
const setTrackerConfig = (param) => {
    if (!sendEvent) {
        console.error('更新设置前请先调用initETracker');
        throw Error('更新设置前请先调用initETracker');
    }
    ETracker.setConfig(param);
};
export { initETracker, sendTrackEvent, ETracker, BuriedEventTrigger, setTrackerConfig };
